import type { QueryClient } from '@tanstack/react-query'

export async function invalidateCommercialQueries(client: QueryClient, accountId: string, subscriptionId?: string) {
  const keys = [
    ['accounts'], ['account', accountId], ['subscriptions'],
    subscriptionId ? ['subscription', subscriptionId] : ['subscription'],
    ['betas'], ['beta-eligibility', accountId], ['account-usage', accountId],
    ['account-history', accountId], ['trial', accountId], ['retention', accountId],
    ['audit'], ['dashboard'],
  ]
  await Promise.all(keys.map(queryKey => client.invalidateQueries({ queryKey })))
}
